import { useEnvs } from "application";
import { ViewPaymentMethods as NewViewPaymentMethods } from "./NewViewMore.component";
import { ViewMore as OldViewPaymentMethods } from "./OldViewMore.component";
import { ViewPaymentMethodsProps } from "./ViewPaymentMethods.types";

export const ViewPaymentMethods = ({
  discountPercentage,
  isMobile,
  maxNumberInstallments,
  salePrice,
  spotPrice,
}: ViewPaymentMethodsProps) => {
  const { allConfigs } = useEnvs();

  const showNewComponent =
    allConfigs?.isOldViewMoreComponentAvailable === "false";

  return showNewComponent ? (
    <NewViewPaymentMethods
      discountPercentage={discountPercentage}
      isMobile={isMobile}
      maxNumberInstallments={maxNumberInstallments}
      salePrice={salePrice}
      spotPrice={spotPrice}
    />
  ) : (
    <OldViewPaymentMethods
      discountPercentage={discountPercentage}
      isMobile={isMobile}
      maxNumberInstallments={maxNumberInstallments}
      salePrice={salePrice}
      spotPrice={spotPrice}
    />
  );
};

export { NewViewPaymentMethods };
